/**
 * Shipping Rates Resource Client
 * Axios-based API client for shipping rates endpoints
 */
export class ShippingRatesResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get shipping rates for a checkout session
     */
    async getShippingRates(sessionId) {
        return this.apiClient.get(`/api/v1/checkout-sessions/${sessionId}/shipping-rates`);
    }
    /**
     * Set selected shipping rate for a checkout session
     */
    async setShippingRate(sessionId, shippingRateId) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/shipping-rate`, {
            shippingRateId,
        });
    }
    /**
     * Preview shipping rates for a country without updating session
     * Useful for showing rates before user enters email
     */
    async previewShippingRates(sessionId, params) {
        const queryParams = new URLSearchParams({ countryCode: params.countryCode });
        if (params.stateCode) {
            queryParams.set('stateCode', params.stateCode);
        }
        return this.apiClient.get(`/api/v1/checkout-sessions/${sessionId}/shipping-rates/preview?${queryParams.toString()}`);
    }
    /**
     * Preview shipping rates for a country AND persist the auto-selected rate on the session.
     *
     * Difference with `previewShippingRates` (which is read-only):
     *   - the server picks the highlighted (or cheapest) rate for `countryCode`
     *   - it writes `checkoutSession.shippingRateId` to the DB
     *   - the next `getCheckout()` will return a summary that includes shipping cost
     *
     * Use this from the studio when geolocation (or any client-side hint) determines a country
     * BEFORE the user submits the full address. Otherwise the wallet sheet (Apple Pay, etc.) will
     * be opened with a stale total that doesn't include shipping fees.
     */
    async selectPreviewShippingRate(sessionId, params) {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/shipping-rates/select-preview`, {
            countryCode: params.countryCode,
            ...(params.stateCode ? { stateCode: params.stateCode } : {}),
        });
    }
}
